import { get } from 'utils/api';
import { ModelJson } from './fetch-model.types';

export type TFetchModelProps = {
  region: string;
  pathname: string;
};

export const fetchModel = (params: TFetchModelProps) => get<ModelJson>('getModel', params);
